import posthog from 'posthog-js';

let _ready = false;
export function markAnalyticsReady(): void { _ready = true; }
export function resetAnalyticsReady(): void { _ready = false; }

function initialized(): boolean { return _ready; }

function bucketPrincipal(principal: number): string {
  if (principal < 50_000) return '<50k';
  if (principal <= 250_000) return '50k-250k';
  return '250k+';
}

export function identifyUser(id: string, email: string): void {
  if (!initialized()) return;
  posthog.identify(id, { email });
}

export function aliasUser(newId: string): void {
  if (!initialized()) return;
  posthog.alias(newId);
}

export function resetUser(): void {
  if (!initialized()) return;
  posthog.reset();
}

export function trackPayoffToolViewed(sourceUrl: string): void {
  if (!initialized()) return;
  posthog.capture('payoff_tool_viewed', { source_url: sourceUrl });
}

export function trackPayoffCalculated(opts: {
  principal: number;
  loanType: string;
  termMonths: number;
}): void {
  if (!initialized()) return;
  posthog.capture('payoff_calculated', {
    loan_type: opts.loanType,
    term_months: opts.termMonths,
    principal_bucket: bucketPrincipal(opts.principal),
  });
}

export function trackPayoffEmailSubmitted(email: string): void {
  if (!initialized()) return;
  posthog.identify(email, { email });
  posthog.capture('payoff_email_submitted', { email });
}

export function trackPayoffPdfDownloaded(): void {
  if (!initialized()) return;
  posthog.capture('payoff_pdf_downloaded');
}

export function trackPromoPageViewed(campaign: string): void {
  if (!initialized()) return;
  posthog.capture('promo_page_viewed', { campaign });
}
